import React from "react";

interface CommentBadgeProps {
    count: number;
    secondCount?: number;
}

export const CommentBadge = ({ count, secondCount }: CommentBadgeProps) => {
    return (
        <div className="comment-badge-container">
            <span className="comment-badge">{count}</span>
            {secondCount !== undefined && (
                <>
                    <span className="text-gray-400">/</span>
                    <span className="comment-badge">{secondCount}</span>
                </>
            )}
        </div>
    );
};
